import { useEffect } from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

//usage: <Redirect url={redirectUrl} />
//this component, on load, will immediately redirect the user to the given URL,
//replacing the navigated url in their history with the redirectURL.
//used to redirect unused static pages while maintaining links

function Redirect({url}) {
    const router = useRouter()
    useEffect(() => {
        // use replace instead of push so that going back doesn't return you to the 'invalid' page and redirect you again
       router.replace(url) 
    }, []);

    return null
}

Redirect.propTypes = {
    url: PropTypes.string,
};
  
export default Redirect;